import React from "react";

const ReactContext = React.createContext();

export default ReactContext;
